import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";
import './index.css'
const trainers = [
  {
    name: "Faizan Ahmed",
    image: "https://storage.googleapis.com/a1aa/image/VOpB3MtC8wJzAtLmjgg7NdYuOtjGxj6zfAJh3zlHMT9j455JA.jpg",
  },
  {
    name: "Faisal Khawaj",
    image: "https://storage.googleapis.com/a1aa/image/xSstPPmtUKJUBNrm1lvdd7c1WbImVensvocw2bKTIcwi455JA.jpg",
  },
  {
    name: "Husnain Shakir",
    image: "https://storage.googleapis.com/a1aa/image/VOpB3MtC8wJzAtLmjgg7NdYuOtjGxj6zfAJh3zlHMT9j455JA.jpg",
  },
  {
    name: "Abdul Saboor",
    image: "https://storage.googleapis.com/a1aa/image/xSstPPmtUKJUBNrm1lvdd7c1WbImVensvocw2bKTIcwi455JA.jpg",
  },
  {
    name: "Ayesha Noor",
    image: "https://storage.googleapis.com/a1aa/image/VOpB3MtC8wJzAtLmjgg7NdYuOtjGxj6zfAJh3zlHMT9j455JA.jpg",
  },
  {
    name: "Ilma Khurram",
    image: "https://storage.googleapis.com/a1aa/image/xSstPPmtUKJUBNrm1lvdd7c1WbImVensvocw2bKTIcwi455JA.jpg",
  },
  
];

const TrainerCard = () => {
  return (
    <div className="Training-Containers text-center">
      <h1 className="my-5">Trainers Staff</h1>
      <div className="row g-4">
        {trainers.map((trainer, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
            <div className="trainer-card">
              <img
                src={trainer.image}
                alt={`Trainer ${trainer.name}`}
                className="img-fluid"
              />
              <h5 className="trainingName">{trainer.name}</h5>
              <div className="social-icons">
                <FontAwesomeIcon icon={faFacebook} className="mx-1 icons" />
                <FontAwesomeIcon icon={faTwitter} className="mx-1 icons" />
                <FontAwesomeIcon icon={faInstagram} className="mx-1 icons" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrainerCard;
